import getToken from "./GetToken";

export const getAuthConfig = () => {

    const token = getToken();

    return {
        headers: { 
            Authorization: `Bearer ${token}`,
            "Accept": 'application/json',
            "Content-Type": 'application/json',
            "Access-Control-Allow-Origin": 'https://*, http://*' 
        }
    }
};